/* eslint-disable import/no-anonymous-default-export */
import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';

export default {
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTypography,
  MuiTooltip: {
    tooltip: {
      fontSize: '0.8em',
    },
  },
  MuiInputLabel: {
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.85)',
    },
  },
  MuiInputBase: {
    input: {
      padding: '6px 0 7px',
    },
  },
  MuiTab: {
    root: {
      minWidth: '160px',
    },
  },
};
